import { IframeMessengerable } from '../IframeMessengerPlayerAbstract';
import { DeviceInformationInterface } from '../interfaces/DeviceInformationInterface';
import { DeviceInformation } from '../types';
import PlayerData from '../enums/PlayerData';
import { ApplicationState } from '../interfaces/ApplicationStateInterface';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function DeviceInformationQueryable<TBase extends IframeMessengerable>(Base: TBase) {
    return class DeviceInformationQueryable extends Base implements DeviceInformationInterface {
        /**
         * Gets information about the device
         * We are not using GET_DEVICE_INFORMATION because it is not supported by all devices
         * For now we have to query ApplicationState to get the device information, for backwards
         * compatibility
         *
         * @throws Error
         * Thrown if the device information is not available
         *
         */
        async getDeviceInformation(): Promise<DeviceInformation> {
            const data = await this._getData<ApplicationState>(PlayerData.APPLICATION_STATE);

            if (!data.device) {
                throw new Error('Could not get device information');
            }

            return {
                model: data.device.model,
                platform: data.device.platform,
                uniqueIdentifier: data.device.uniqueIdentifier,
                serial: data.device.serial,
                vendor: data.device.vendor,
                browserPlatform: data.device.browserPlatform,
                browserName: data.device.browserName,
                browserVersion: data.device.browserVersion,
                osName: data.device.osName,
                osVersion: data.device.osVersion,
            };
        }
    };
}
